/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchPoolsCoinResponse } from './search-pools-coin-response';


export interface SearchPoolsResponse { 
    id: string;
    name: string;
    coins?: Array<SearchPoolsCoinResponse> | null;
}

